<script lang="ts">

    import { redirectTo } from "../scripts/router1";
    import { idPageEntreprise } from "../scripts/router2";
    import { storeEnterpriseId, Enterprise } from "../scripts/enterprise";

    export let props: Enterprise;

    /**
     * selectEnterprise
     * @param id
     */
    function selectEnterprise(id: number) {
        storeEnterpriseId.set(id);
        redirectTo(idPageEntreprise, "?id="+id);
    }
    
</script>

<style lang="scss">

	.tileenterprise {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        &__img {
            width: 100%;
            padding: 15px;
        }
	}

    @include large {
        .tileenterprise {
            width: 30%;
            &__img {
                width: 100%;
                max-width: 350px;
                cursor: pointer;
                transition: all 0.5s;
                &:hover {
                    transform: scale(0.8);
                }
            }
        }
    }

</style>

<div class="tileenterprise" on:click={() => selectEnterprise(props.id)} on:keydown={() => selectEnterprise(props.id)}>
    <img class="tileenterprise__img" title={props.name} alt={props.name} src="../assets/images/enterprises/{props.id}_{props.logo}">
</div>
